import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
export function Topbar({ crumbs, rightSlot }) {
    return (_jsxs("header", { className: "topbar", children: [_jsx("div", { className: "topbar__crumbs", children: crumbs.map((c, i) => {
                    const isLast = i === crumbs.length - 1;
                    const cls = `topbar__crumb ${isLast ? 'is-current' : ''}`;
                    const inner = !isLast && c.to ? (_jsx(Link, { to: c.to, className: cls, children: c.label })) : (_jsx("span", { className: cls, children: c.label }));
                    return (_jsxs(Fragment, { children: [i > 0 && _jsx("span", { className: "topbar__crumb-sep", children: "/" }), inner] }, `${i}-${c.label}`));
                }) }), rightSlot ? _jsx("div", { className: "topbar__right", children: rightSlot }) : null] }));
}
//# sourceMappingURL=Topbar.js.map